import React from 'react';

import darkLogo from './images/2023/AR_Logo_SmallScale_Black.png';
import grayLogo from './images/2023/AR_Logo_SmallScale_Icon_gray.png';

const resolveImageSource = (type) => {
  switch (type) {
    case 'darkbg':
      return darkLogo;
    case 'gray':
    case 'lightbg':
    case 'transparentbg':
      return grayLogo;
    default:
      return darkLogo;
  }
};

const Logo = ({ type, isLiveBooking }) => {
  const src = resolveImageSource(type);
  return (
    <img className={`Logo ${isLiveBooking && 'Logo-live'}`} src={src} alt="" />
  );
};

export default Logo;
